import { useEffect, useState, useRef, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import Pagination from 'react-js-pagination'
import Select from 'react-select'
import { autosuggestStyles } from '../utils'
import { connect } from 'react-redux'
import API from 'api'
import Loader from '../../helpers/Loader'
import ReviewCard from './ReviewCard'
import { ReviewAddButtons } from './ReviewAddButtons'
import { ReviewAddedView } from './ReviewAddedView'

import '../styles/reviews.scss'

const orderingChoices = [
  {
    value: 'most_recent',
    title: <FormattedMessage id='most_recent' defaultMessage='Most recent' />,
  },
  {
    value: 'best_reviews',
    title: <FormattedMessage id='best_reviews' defaultMessage='Best reviews' />,
  },
  {
    value: 'worst_reviews',
    title: (
      <FormattedMessage id='worst_reviews' defaultMessage='Worst reviews' />
    ),
  },
]

const Reviews = ({ diveSite, reviewAdded }) => {
  const reviewsRef = useRef(null)
  const isInitialMount = useRef(true)
  const [reviews, setReviews] = useState([])
  const [page, setPage] = useState(1)
  const [reviewsAmount, setReviewsAmount] = useState(0)
  const [ordering, setOrdering] = useState('most_recent')
  const [isLoading, setLoading] = useState(true)

  const { id } = diveSite

  useEffect(() => {
    setLoading(true)
    if(!isInitialMount.current) {
      window.scrollTo(0, reviewsRef.current.offsetTop)
    }

    API(`dive-guide/adventure-dive-site/reviews/`)
      .get({
        adventure_dive_site_id: id,
        page,
        ordering: ordering.value,
      })
      .then((res) => {
        setReviews(res.results || [])
        setReviewsAmount(res.count)
      })
      .finally(() => {
        setLoading(false)
        isInitialMount.current = false
      })
  }, [page, ordering, reviewAdded])

  const onPageChange = (page) => {
    setPage(page)
  }

  const onOrderingChange = (value) => {
    setOrdering(value)
  }

  return (
    <Fragment>
      <div className='homepage-section__title-center homepage-section__title-center--sm'>
        {reviewsAmount ? (
          <FormattedMessage
            id='add_your_review'
            defaultMessage='Add your review'
          />
        ) : (
          <FormattedMessage
            id='be_first_review'
            defaultMessage='Be the first to leave a review'
          />
        )}
      </div>
      <div
        className={`reviews ${isLoading ? 'react-app-loading' : ''}`}
        ref={reviewsRef}
      >
        <Loader />
        {reviewAdded ? <ReviewAddedView /> : <ReviewAddButtons />}
        {!!reviewsAmount && (
          <Fragment>
            <h4 className='reviews__title'>
              <FormattedMessage
                id='written_reviews'
                defaultMessage='Written reviews'
              />
            </h4>
            {/* <ReviewsMentions/> ignored for now */}
            <div className='reviews__header'>
              <div className='reviews__amount'>
                <FormattedMessage
                  id='reviews.reviews_amount'
                  defaultMessage='{reviews, plural, one {# review} other {# reviews}}'
                  values={{
                    reviews: reviewsAmount,
                  }}
                />
              </div>
              <div className='reviews__select'>
                <Select
                  onChange={onOrderingChange}
                  value={ordering}
                  options={orderingChoices}
                  styles={autosuggestStyles}
                  placeholder={
                    <FormattedMessage id='sort_by' defaultMessage='Sort by' />
                  }
                  getOptionLabel={(option) => option.title}
                  getOptionValue={(option) => option.value}
                  className='select-container'
                />
              </div>
            </div>
            <div className='reviews_list'>
              {reviews.map((item) => (
                <ReviewCard
                  key={item.objectId}
                  review={item}
                  diveSite={diveSite}
                />
              ))}
            </div>
            {reviewsAmount > 5 && (
              <div className='pagination-wrap'>
                <Pagination
                  activePage={page}
                  itemsCountPerPage={5}
                  totalItemsCount={reviewsAmount}
                  innerClass='dg-pagination'
                  itemClassPrev='prev'
                  itemClassNext='next'
                  prevPageText=''
                  nextPageText=''
                  itemClassFirst='hidden'
                  itemClassLast='hidden'
                  onChange={onPageChange}
                  pageRangeDisplayed={5}
                />
              </div>
            )}
          </Fragment>
        )}
      </div>
    </Fragment>
  )
}

const mapStateToProps = (state) => ({
  reviewAdded: state.reviewAdded,
})

export default connect(mapStateToProps)(Reviews)
